<template>
    <Teleport to=".sub-header" v-if="ticketType !== TicketType.SOLO">
        <div class="header-tabs header-tabs--full-w">
            <TicketTabs />
        </div>
    </Teleport>
    <div class="ticket-mobile" :class="{ 'ticket--kombi': ticketType === TicketType.KOMBI }">
        <TicketPlaced v-if="ticketStore.placed && !ticketStore.sendingInProgress" />
        <TicketEmpty v-else-if="isEmptyTicket && !ticketStore.sendingInProgress" />
        <div class="ticket-main" v-else>
            <TicketErrors />
            <TicketGroup />
            <TicketPrice />
            <TicketMistakes />
            <TicketFooter />
        </div>
        <TicketLoader />
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, watch } from "vue";
import { useRouter } from "vue-router";

import TicketTabs from "@/ticket/components/molecules/TicketTabs.vue";
import TicketGroup from "@/ticket/components/molecules/TicketGroup.vue";
import TicketErrors from "@/ticket/components/molecules/TicketErrors.vue";
import TicketEmpty from "@/ticket/components/atoms/TicketEmpty.vue";
import TicketPlaced from "@/ticket/components/atoms/TicketPlaced.vue";
import TicketFooter from "@/ticket/components/molecules/TicketFooter.vue";
import TicketPrice from "@/ticket/components/molecules/TicketPrice.vue";
import TicketMistakes from "@/ticket/components/molecules/TicketMistakes.vue";
import TicketLoader from "@/ticket/components/atoms/TicketLoader.vue";
import { useTicketStore } from "@/ticket/stores/use-ticket-store";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { TicketType } from "@/shared/model/ticket";
import analytics from "@/shared/analytics";

const router = useRouter();
const { isMobile } = useIsBreakpoint();

const ticketStore = useTicketStore();

const ticketType = computed(() => ticketStore.ticketType);
const isEmptyTicket = computed(() => ticketStore.empty && !ticketStore.ticketOutcomeCount);

onMounted(() => {
    if (!isMobile.value) router.push({ name: "Homepage" });
    analytics.sendPageView();
});

watch(
    () => isMobile.value,
    (newValue) => {
        if (!newValue) router.push({ name: "Homepage" });
    },
);
</script>
